import { AnimalScreeningReportVendors } from "shared/types";
import { BarChart01, LinkExternal01 } from "untitledui-js-base";
import { getLogoSrc } from "utils/getLogoSrc";
import { Section } from "views/applications-id-report/components/Section";

import { Link } from "react-router-dom";

import { APPROVED_PET_STATUSES } from "../constants";

import { Stat } from "views/applications-id-report/components/Stat";

import { getVerificationStatusByVendor } from "../utils";
import { OurPetPolicyAnimal } from "../types/our-pet-policy";
import { PetScreeningAnimal } from "../types/pet-screening";

export const AnimalScreeningStats = ({
  vendor,
  detailsPageUrl,
  pets
}: {
  vendor: AnimalScreeningReportVendors;
  detailsPageUrl?: string;
  pets?: (OurPetPolicyAnimal | PetScreeningAnimal)[];
}) => {
  return (
    <Section
      sectionTitle="Summary"
      maxWidth="100%"
      icon={<BarChart01 size="20px" className="stroke-content-500" />}
    >
      <div className="pt-3 pb-6 border-b border-alpha-40 mb-6">
        <img
          className={
            vendor === AnimalScreeningReportVendors.OurPetPolicy
              ? "h-[22px]"
              : "h-[14px]"
          }
          src={getLogoSrc(vendor)}
          alt={vendor + "logo"}
        />
      </div>
      <div className="flex justify-between items-center">
        <Stat title="Pets/Assistance animals" value={pets?.length || 0} />
        <div className="ml-auto">
          <p className="text-content-1000 font-bold text-right text-sm mb-2">
            {vendor === AnimalScreeningReportVendors.PetScreening
              ? "View on PetScreening.com"
              : "View on ourpetpolicy.com"}
          </p>
          <Link
            to={detailsPageUrl || ""}
            className="text-primary-500 text-sm flex gap-2 items-center font-medium underline max-w-[300px] w-full"
            target="_blank"
            rel="noopener noreferrer"
          >
            <LinkExternal01
              size="16px"
              strokeWidth={1.5}
              className="shrink-0 stroke-primary-500  "
            />
            <p className="truncate">
              {detailsPageUrl
                ?.replace("https://landlord.", "")
                ?.replace("https://app.", "")}
            </p>
          </Link>
        </div>
      </div>
    </Section>
  );
};
